











































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

import { ListItem, SkeletonBox } from '@/layouts/components'

import { Invoice, OrderPayment } from '@/models'

import OrderPaymentStatusChip from './OrderPaymentStatusChip.vue'
import RelativeTime from './RelativeTime.vue'
import { isFood } from '@/utils'

@Component({
  components: {
    ListItem,
    OrderPaymentStatusChip,
    RelativeTime,
    SkeletonBox
  }
})
export default class OrderPaymentTile extends Vue {
  @Prop({ type: Object, required: true })
  readonly orderPayment!: OrderPayment

  @Prop({ type: Boolean, default: false })
  readonly relativeTime!: boolean

  get invoice (): Invoice | null {
    return this.invoiceById(this.orderPayment.ownerId)
  }

  get locations () {
    return this.invoice
      ? this.invoiceLocations(this.invoice)
      : null
  }

  get invoiceTitle () {
    return isFood() ? 'Comanda' : 'Compra'
  }

  @Getter('ordering/invoiceById')
  readonly invoiceById!: (id: number) => Invoice | null

  @Getter('ordering/invoiceLocations')
  readonly invoiceLocations!: (invoice: Invoice) => string[] | null
}
